import React from "react";
import { Link } from "react-router-dom";

const Menu = () => {
  return (
    <aside className="menu">
      <a href="./flyer.pdf" target="_blank" rel="noopener noreferrer">
        Programme
      </a>
      <Link to="/restitution">Restitutions</Link>
      <Link to="/medialibrary">Media Library</Link>
      <Link to="/ressource">Ressources Techniques</Link>
      <a href="https://www.upyaconnect.org/fr" target="_blank" rel="noopener noreferrer">
        Hub de connaissances
      </a>
    </aside>
  );
};

export default Menu;
